export default { sha: '6ef07f7e72c975398620d258188b3bea7f8d15da', buildNumber: 'undefined' }
